export default "<m-cylinder\n    color=\"yellow\"\n    y=\"3\"\n    sx=\"3\"\n    sy=\"2\"\n    sz=\"3\"\n></m-cylinder>\n";